import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import axios from 'axios'
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'

const pinia = createPinia()
loadFonts()

axios.defaults.baseURL = 'https://aurorafinder.app/api/'

const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = token
}

createApp(App)
  .use(VuePlyr, {
    plyr: {}
  })
  .use(pinia)
  .use(router)
  .use(vuetify)
  .mount('#app')
